import React from 'react'
import { Alert, Row, Col, Grid, Label, Button, ButtonGroup } from 'react-bootstrap'
import { Link } from 'react-router'
import Icon from './icon'
import icons from '_/config/icons.json'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import getDisplayName from '_/utils/getDisplayName'
import Input from '_/shared/components/input'

/**
 * Top navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class TopNav extends React.Component {
  static propTypes = {
    account: React.PropTypes.object,
    lastResult: React.PropTypes.any,
    isMap: React.PropTypes.bool,
    path: React.PropTypes.string
  }

  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func
  }

  renderNonAdminNav () {
    const { lastResult, isMap, account } = this.props
    const metro = account.get('group').get('metro')
    const isMNBase = metro && metro.get('statesM').includes('MN')
    const isAgRes = account.get('isAgRes')
    const isMNCARGroup = account.get('group').get('name') === 'MNCAR Association'

    return (
      <div>
        {!isMNCARGroup &&
          <Link className="btn text-info" to="my-records">
            <Icon name={icons.database} /> My records
          </Link>
        }
        <a className="btn text-danger" href="/projects/assigned">
          <Icon name={icons.project} /> Projects
        </a>
        {!isMap && !isAgRes &&
          <Link className="btn" to="map-search">
            <Icon name={icons.map} /> Map search
          </Link>
        }
        <Link className="btn btn-info" to="text-search">
          <Icon name={icons.search} /> Search
        </Link>
        {lastResult &&
          <Link className="btn text-success" to={lastResult}>
            <Icon name={icons.history} /> Last results
          </Link>
        }
        {isMNBase &&
          <Link className="btn" to="gis">
            <Icon name={icons.gis} /> GIS
          </Link>
        }
        {!isMNCARGroup &&
          <a className="btn text-danger" href="/library">
            <Icon name={icons.library} /> Library
          </a>
        }
      </div>
    )
  }

  renderAdminNav () {
    const { account, lastResult, isMap } = this.props
    const metro = account.get('group').get('metro')
    const isMNBase = metro && metro.get('statesM').includes('MN')

    return (
      <div>
        <Link className="btn text-info" to="my-records">
          <Icon name={icons.database} /> Records
        </Link>
        <a className="btn text-info" href="/tasks">
          <Icon name={icons.task} />
          &nbsp;
          <Label bsStyle="info">
            {account.get('taskCount')}
          </Label>
        </a>
        {!isMap &&
          <a className="btn text-info" href="/inspections">
            <Icon name={icons.completed} /> Insp
          </a>
        }
        {!isMap &&
          <Link className="btn" to="map-search">
            <Icon name={icons.map} /> Map search
          </Link>
        }
        <Link className="btn" to="text-search">
          <Icon name={icons.search} /> Search
        </Link>
        {lastResult &&
          <Link className="btn text-success" to={lastResult}>
            <Icon name={icons.history} /> Last results
          </Link>
        }
        {isMNBase &&
          <Link className="btn" to="gis">
            <Icon name={icons.gis} /> GIS
          </Link>
        }
        <ButtonGroup>
          <a className="btn text-danger" href="/groups" title="Group"><Icon name={icons.group}/></a>
          <a className="btn text-danger" href="/users" title="Users"><Icon name={icons.user}/></a>
          <a className="btn text-danger" href="/metros" title="Metros"><Icon name={icons.metro}/></a>
          <a className="btn text-danger" href="/vendors" title="Vendors"><Icon name={icons.vendor}/></a>
        </ButtonGroup>
      </div>
    )
  }

  handleOptions (data) {
    return data.map(r => {
      return { value: r.get('id'), label: `${getDisplayName('property', r)} - ${r.get('pid')}` }
    }).toJS()
  }

  handleSelect (recordId) {
    if (!recordId) return
    const { router } = this.context
    router.transitionTo('record', { id: recordId })
  }

  render() {
    const { account, isMap } = this.props
    const { store } = this.context
    const isDelinq = account.getIn(['group', 'isDelinq'])

    return (
      <div>
        {store && store.assumingUser &&
          <Alert bsStyle="danger">
            <Button
              className="pull-right"
              bsSize="xsmall"
              bsStyle="danger"
              href="/tasks/unassume">
              Stop assuming user
            </Button>
            <b>Assuming the identity of another user!</b>  Ensure you are operating out of the right group and stop assuming when finished.
          </Alert>
        }
        <div className="redi-component-top-nav">
          <Grid fluid>
            <div className="pull-right text-right">
              {account.get('isAdmin')
                ? this.renderAdminNav()
                : !isDelinq && this.renderNonAdminNav()}
              <p>
                Your current active group is:&nbsp;
                <strong>{account.getIn(['group','name'])}</strong>&nbsp;
                <Link className="btn btn-xs btn-success" to="switch-plan">
                  Switch
                </Link>
              </p>
            </div>

            {!isMap &&
              <Row>
                <Col xs={1}>
                  <Link to="dashboard">
                    <img style={{height: 40}} src="/images/logos/logo-2x.png"/>
                  </Link>
                </Col>
                {!isDelinq &&
                  <Col xs={3} style={{paddingLeft: 30}}>
                    <Input
                      type="select-ajax"
                      className="redi-component-go-to-record"
                      handleOptions={::this.handleOptions}
                      onChange={::this.handleSelect}
                      placeholder="Go to record..."
                      name="records"
                      url="/records?isPrivate=false&minimal=true" />
                  </Col>
                }
              </Row>
            }
          </Grid>
        </div>
      </div>
    )
  }
}

export default TopNav



// WEBPACK FOOTER //
// ./modules/shared/components/topNav.js